import { getRouteApi, Navigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { Typography } from "@/components/Typography";
import { useEnableContractSigning } from "@/features/contract/useEnableContractSigning";
import { PageLayout } from "@/pages/components/PageLayout";
import { PageTitle } from "@/pages/components/PageTitle";
import { SigningFlow } from "@/pages/contractSigning/SigningFlow";

const routeApi = getRouteApi("/contract-signing");

const ContractSigningPage: React.FC = function ContractSigningPage() {
  const { t } = useTranslation();
  const { product, return_url: returnUrl } = routeApi.useSearch();
  const isEnabled = useEnableContractSigning();

  // Gated here, not only in the sidebar: otherwise the page stays reachable by
  // URL for orgs the feature is not released to, which then only see
  // interlude's "not available" error. interlude is what withholds the data;
  // this keeps the two surfaces telling the same story.
  if (!isEnabled) {
    return <Navigate to="/applications" replace />;
  }

  // Customers always arrive from a product redirect that names the product. A
  // link without a recognizable one cannot answer "which contract am I
  // signing", and guessing would put a legally binding agreement in front of
  // the wrong text — so send them back instead of choosing for them.
  if (product === undefined) {
    return <Navigate to="/applications" replace />;
  }

  return (
    <PageLayout>
      <PageTitle>
        {t("contractSigning.title", "Service Agreement Signing")}
      </PageTitle>
      <Typography variant="note">
        {t(
          "contractSigning.subtitle",
          "Please review the following contracts and agree to continue using the service.",
        )}
      </Typography>
      <SigningFlow product={product} returnUrl={returnUrl} />
    </PageLayout>
  );
};

export { ContractSigningPage };
